import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { Logout } from '@shared/store/shared.actions';

@Component({
  selector: 'prp-403',
  templateUrl: './403.component.html',
  styleUrls: ['./403.component.scss'],
})
export class Error403Component implements OnInit {
  public missingRole$: Observable<string>;

  constructor(private store: Store, private route: ActivatedRoute) {
    this.missingRole$ = this.route.queryParamMap.pipe(
      map((params) => {
        return params.get('missingRole');
      })
    );
  }

  ngOnInit() {}

  logout() {
    this.store.dispatch(new Logout());
  }
}
